import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Errors, actions } from 'react-redux-form';

// import { InputField } from '../../../../common/custom-form/input-filter-component';
import { MAX_LENGTH } from "../../../../../constants/external-constants";
import { InputAutoSuggest } from '../../../../common/custom-form/input-auto-suggest.component';
import DATEPICKER_OR from "../../../../common/custom-form/custom-date-picker.component";
import { TabberButton } from '../../../../common/custom-form/tabber-button.component';
import LineManager from '../DetailsView/LineManager/LineManager';
import "../../hr-management.css";
import { Button } from 'react-bootstrap';
import ApproverDetails from '../DetailsView/ApproverDetails/ApproverDetails';
import AddressDetails from '../../../inventory/DetailsView/add-address.component';
import { CustomDropdown } from '../../../../common/custom-form/custom-dropdown.component';
import AddCostAllocation from '../DetailsView/AddCostAllocation/AddCostAllocation';
import { TRANSLATIONS as translation, STRING_VALUES as stringValues, ERROR_SOURCE } from '../../../../../utils/constant.utils';
import { ConfirmationModal } from '../../../../common/modal/modal.component';
import { NotificationModal } from '../../../../common/modal/notification-modal.component';
import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel } from '../../../../common/custom-form/select-filter.component';
import { hrDetailsActions } from "../../../../../store/external/manage-user/form/manage-user-form.reducer";
import { NoSubscription } from '../../../dashboard/no-subscription/no-subscription.component';
import { areDataEqual, isObjectEqual } from '../../../../../utils/helpers.utils';
import { userCostAllocationActions } from '../../../../../store/external/manage-user/form/user-add-cost-allocation.reducer';
import CustomSearchableSelectWrapper from "../../../../common/custom-form/custom-searchable-select-wrapper.component";
import AccessManagement from '../DetailsView/AccessManagement/AccessManagement';
import CustomSearchableDropdownWrapper from '../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';
class ManageUserForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saveModal: {
                title: "",
                messageBody: "",
                costCode: [],
                isLoading: true,
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            inProgress: true,
            userId: 0,
            lineManagerHrId: "",
            originalCostAllocationData: {},
            error: {
                propertyName: "",
                isSuccess: false
            }
        };

        this.CostCenterAutoSuggest = React.createRef();
        this.TabberButtonIsVIP = React.createRef();
        this.LocationSiteIdAutoSuggest = React.createRef();
        this.ConfirmationModal = React.createRef();
        this.onChangeCostCenter = this.onChangeCostCenter.bind(this);
    }

    async componentDidMount() {
        const { employeeId, userId, getHrLocationAddress, getHrLineManager, getHRDetails, manageUserHrDetailsForm, getCostCodeDetailList, getCostCodeList } = this.props;

        var hrDetails = await getHRDetails(employeeId);

        let costCodes;
        if (hrDetails?.CostCenter?.CostCodeName) {
            costCodes = await getCostCodeDetailList(1, hrDetails.CostCenter.CostCodeName);
        }
        else {
            costCodes = await getCostCodeDetailList();
        }

        this.setState({ costCode: this.modifyOption(costCodes) })
            
        if (hrDetails?.LocationAddress?.LocationSiteId) {
            await getHrLocationAddress(1, hrDetails.LocationAddress.LocationSiteId);
        }
        else {
            await getHrLocationAddress();
        }

        if (hrDetails?.LineManager?.LineManagerHrId) {
            await getHrLineManager(1, hrDetails.LineManager.LineManagerHrId);
        }
        else {
            await getHrLineManager();
        }

        await getCostCodeList();
        

        this.toggleButton(hrDetails);
        var userDetailsId = userId > 0 ? userId : ((manageUserHrDetailsForm && manageUserHrDetailsForm.userId > 0) ? manageUserHrDetailsForm.userId : userId);

        await this.props.getAddCostAllocation(userDetailsId).then(() => {
            const originalCostAlloDataCopy = JSON.parse(JSON.stringify(this.props.manageUserCostAllocation));
            this.setState({ originalCostAllocationData: originalCostAlloDataCopy })
        });

        this.setState({
            inProgress: false, lineManagerHrId: hrDetails != undefined ?
                ((hrDetails.LineManager != null || hrDetails.LineManager != undefined) ?
                    hrDetails.LineManager.LineManagerHrId : '') : '', userId: hrDetails != undefined ?
                        hrDetails.UserId : '0'
        });

    }

    componentWillUnmount() {
        this.props.resetfetchingHrDetails();
        this.props.resetmanageUserHrDetailsForm();
        this.props.resetCostAllocation();
    }

    modifyOption = (options) => {
        return options.map(option => ({
            ...option,
            Value: `${option.Value} ~ ${option.Label}`
        }));
    }

    handleOpenNotif = () => {
        this.setState(prevState => ({
            saveNotif: {
                ...prevState.saveNotif,
                show: true
            }
        }));
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });
    }
    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    onChangeCostCenter = (fieldProps, e) => {
        const { FormChange, selectCostCenter } = this.props;
        const {  costCodeDetailsOptions } = this.props.manageUserCostAllocation;
        if (!e) {
            selectCostCenter();
            return;
        }
        FormChange(fieldProps, e);
        const selectedCostCode = costCodeDetailsOptions?.find(r => r.Key === e);
        console.log(selectedCostCode);

        if (selectedCostCode) {
            selectCostCenter(selectedCostCode.Value);
        } else {
            selectCostCenter();
        }
    };

    onChangeLocationSite = (fieldProps, e) => {
        const { locationAddressDropdownList } = this.props.manageUserHrDetails
        this.props.FormChange(fieldProps, e)

        let location;
        if (typeof e === "number" && Number.isInteger(e)) {
            location = locationAddressDropdownList.find(r => r.Key === e)?.Value ?? e;
        }
        else {
            location = e
        }
        this.props.selectLocationSite("LocationId", location);
    }

    toggleButton = (hrDetails) => {
        if (hrDetails) {
            if (this.TabberButtonIsVIP.current) {
                this.TabberButtonIsVIP.current.toggle(hrDetails.IsVIP ?? false);
            }
        }
    }

    disableSaveChanges = () => {
        if (!this.state.inProgress) {
            const { manageUserHrDetailsForm, $form, manageUserCostAllocation } = this.props;

            let initialFormValue = { ...$form.loadedValue };
            delete initialFormValue.approverCostCenterAuthorizer
            delete initialFormValue.approverWireline
            delete initialFormValue.firstLineManagerEmailAddress
            delete initialFormValue.firstLineManagerFullName
            delete initialFormValue.firstLineManagerStatus
            delete initialFormValue.secondLineManagerEmailAddress
            delete initialFormValue.secondLineManagerFullName
            delete initialFormValue.secondLineManagerHrId
            delete initialFormValue.secondLineManagerStatus
            let updatedFormValue = { ...manageUserHrDetailsForm };
            delete updatedFormValue.approverCostCenterAuthorizer
            delete updatedFormValue.approverWireline
            delete updatedFormValue.firstLineManagerEmailAddress
            delete updatedFormValue.firstLineManagerFullName
            delete updatedFormValue.firstLineManagerStatus
            delete updatedFormValue.secondLineManagerEmailAddress
            delete updatedFormValue.secondLineManagerFullName
            delete updatedFormValue.secondLineManagerHrId
            delete updatedFormValue.secondLineManagerStatus

            const unchangedUserHrDetails = isObjectEqual(initialFormValue, updatedFormValue);
            const updatedCostCodeApprover = manageUserHrDetailsForm.approverCostCenterAuthorizer === stringValues.stringZero ? stringValues.stringNull : manageUserHrDetailsForm.approverCostCenterAuthorizer;
            const updatedWirelineApprover = manageUserHrDetailsForm.approverWireline === stringValues.stringZero ? stringValues.stringNull : manageUserHrDetailsForm.approverWireline;
            const unchangedLineManager = manageUserHrDetailsForm.firstLineManagerHrId !== undefined
                ? (areDataEqual(this.state.lineManagerHrId, manageUserHrDetailsForm.firstLineManagerHrId))
                : (this.state.lineManagerHrId !== '' ? false : true);
            const unchangedCostCodeApproverDetails = $form.loadedValue !== undefined ? areDataEqual($form.loadedValue.approverCostCenterAuthorizer, updatedCostCodeApprover) : false;
            const unchangedWirelineApproverDetails = $form.loadedValue !== undefined ? areDataEqual($form.loadedValue.approverWireline, updatedWirelineApprover) : false;
            const userCostAllocationDetails = manageUserCostAllocation?.userCostAllocation?.datatable?.length > 0
                ? areDataEqual(this.state.originalCostAllocationData.userCostAllocation.datatable[0].dataItem, manageUserCostAllocation.userCostAllocation.datatable[0].dataItem)
                : true

            let disabled = !manageUserHrDetailsForm.hrSapId
                || !manageUserHrDetailsForm.firstName
                || !manageUserHrDetailsForm.lastName
                || !manageUserHrDetailsForm.emailAddress
                || !manageUserHrDetailsForm.costCenterId
                || !manageUserHrDetailsForm.statusId
                || !manageUserHrDetailsForm.roleId;

            if ((unchangedCostCodeApproverDetails && unchangedWirelineApproverDetails && userCostAllocationDetails) || disabled) {
                return unchangedUserHrDetails || disabled;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }

    handleSaveManageHR = async (employeeId, validate = 1) => {
        const { saveManageHRForm, getHRDetails, manageUserHrDetailsForm, userId } = this.props;

        this.setState({
            isSaving: true
        });

        var result = await saveManageHRForm(employeeId, validate);
        this.setState({
            isSaving: false
        });

        if (result.success) {
            if (result.isValid) {
                const confirmMessage = "Are you sure you want to save?";
                const modalTitle = this.toLocaleLanguage("call_save", false);
                var confirmAction = () => this.handleSaveManageHR(manageUserHrDetailsForm.employeeId, 0);
                this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                return;
            }
            else {
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title", false), result.message);

                const data = result.data;
                const hrDetails = await getHRDetails(data.employeeId);
                this.toggleButton(hrDetails);
                var userDetailsId = userId > 0 ? userId : ((hrDetails && hrDetails.UserId > 0) ? hrDetails.UserId : userId);
                await this.props.getAddCostAllocation(userDetailsId).then(() => {
                    const originalCostAlloDataCopy = JSON.parse(JSON.stringify(this.props.manageUserCostAllocation));
                    this.setState({ originalCostAllocationData: originalCostAlloDataCopy })
                });
                this.props.setEmployeeId(data.employeeId);
                this.setState({ error: { propertyName: "", isSuccess: false }, lineManagerHrId: hrDetails != undefined ? ((hrDetails.LineManager != null || hrDetails.LineManager != undefined) ? hrDetails.LineManager.LineManagerHrId : '') : '' })
            }
        }
        else {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
            this.setState({ error: { propertyName: result.propertyName, isSuccess: result.success } })
            return;
        }
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    handleLocationSearch = (query) => {
        this.props.getHrLocationAddress(1, query)

        if (query === '' || query === null) {
            this.props.resetLocation();
        }
    }

    loadMoreLocation = (searchString) => {
        const { manageUserHrDetails } = this.props;
        this.props.getHrLocationAddress(manageUserHrDetails.locationPage + 1, searchString);
    }

    handleCostCodeSearch = (query) => {
        this.props.getCostCodeDetailList(1, query);
    }

    loadMoreCostCode = (searchString) => {
        const { costCodePage } = this.props.manageUserCostAllocation;
        this.props.getCostCodeDetailList(costCodePage + 1, searchString);
    }


    render() {
        const { manageUserHrDetails, manageUserHrDetailsForm } = this.props;
        const { isCostCodeLoading, hasMoreCostCode, costCodeDetailsOptions } = this.props.manageUserCostAllocation;

        const transformCostCode = this.modifyOption(costCodeDetailsOptions);

        let userDetailsId = this.state.userId > 0 ? this.state.userId : ((manageUserHrDetailsForm && manageUserHrDetailsForm.userId > 0) ? manageUserHrDetailsForm.userId : this.state.userId);

        return (
            <>
                {manageUserHrDetails.fetchingHrDetails
                    ? <NoSubscription /> :
                    <>
                        <div className="hr-management-form-container details-container mb-3 invoice-detail-container">
                            <div className="details-field-container">

                                <InputField
                                    className="form-control required"
                                    type="text"
                                    label={this.toLocaleLanguage("hr_sap_id")}
                                    value={manageUserHrDetailsForm.hrSapId ?? ""}
                                    fieldProp='manageUserHrDetailsForm.hrSapId'
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                    requiredField={true}
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={this.toLocaleLanguage("firstname")}
                                    value={manageUserHrDetailsForm.firstName ?? ""}
                                    fieldProp='manageUserHrDetailsForm.firstName'
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                    requiredField={true}

                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={this.toLocaleLanguage("lastname")}
                                    value={manageUserHrDetailsForm.lastName ?? ""}
                                    fieldProp='manageUserHrDetailsForm.lastName'
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                    requiredField={true}

                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={this.toLocaleLanguage("middle_initial_capital")}
                                    value={manageUserHrDetailsForm.middleInitial ?? ""}
                                    fieldProp='manageUserHrDetailsForm.middleInitial'
                                    maxLength={MAX_LENGTH.limit_5}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={this.toLocaleLanguage("email_address_capital")}
                                    value={manageUserHrDetailsForm.emailAddress ?? ""}
                                    fieldProp='manageUserHrDetailsForm.emailAddress'
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                    requiredField={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={this.toLocaleLanguage("job_title")}
                                    value={manageUserHrDetailsForm.jobTitle ?? ""}
                                    fieldProp='manageUserHrDetailsForm.jobTitle'
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                />

                                <CustomSearchableDropdownWrapper
                                    label={`${this.toLocaleLanguage("cost_center")}`}
                                    options={transformCostCode}
                                    selected={transformCostCode.length > 0 ? manageUserHrDetailsForm.costCenterId : ''}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    onChange={(e) => this.onChangeCostCenter('manageUserHrDetailsForm.costCenterId', e)}
                                    requiredField
                                    fieldProp="manageUserHrDetailsForm.costCenterId"
                                    tagName='Key'
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    hasTilde={true}
                                    maxLength={MAX_LENGTH.limit_255}
                                    onSearchChange={this.handleCostCodeSearch}
                                    onLoadMore={this.loadMoreCostCode}
                                    isLoading={isCostCodeLoading}
                                    hasMore={hasMoreCostCode}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={this.toLocaleLanguage("cost_center_authorizer")}
                                    value={manageUserHrDetailsForm.costCenterAuthorizer ?? ""}
                                    fieldProp='manageUserHrDetailsForm.costCenterAuthorizer'
                                    maxLength={MAX_LENGTH.limit_100}
                                    disabled={true}
                                />
                                <SelectFieldFloatingLabel
                                    className="form-select required"
                                    label={`${this.toLocaleLanguage('status_capital')}`}
                                    options={manageUserHrDetails.statusDropdown}
                                    value={manageUserHrDetailsForm.statusId ?? ""}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='manageUserHrDetailsForm.statusId'
                                    optionLabelKey={{
                                        Key: "Key",
                                        Value: "Value"
                                    }}
                                />
                                <div className="date-picker-main-container">
                                    <DATEPICKER_OR
                                        dateOnly={true}
                                        label={`${this.toLocaleLanguage('hire_date')}`}
                                        startDate={manageUserHrDetailsForm.hireDate}
                                        selectedDate={(date) => this.props.FormChange("manageUserHrDetailsForm.hireDate", date)}
                                        placeholder={this.toLocaleLanguage('select_placeholder')}
                                    />
                                </div>
                                <div className="date-picker-main-container">
                                    <DATEPICKER_OR
                                        dateOnly={true}
                                        label={`${this.toLocaleLanguage('date_left')}`}
                                        startDate={manageUserHrDetailsForm.dateLeft}
                                        selectedDate={(date) => this.props.FormChange("manageUserHrDetailsForm.dateLeft", date)}
                                        placeholder={this.toLocaleLanguage('select_placeholder')}
                                    />
                                </div>

                                <div className="tabber-form-container">
                                    <TabberButton ref={this.TabberButtonIsVIP} title="VIP" onToggle={(isActive) => this.props.FormChange("manageUserHrDetailsForm.isVIP", isActive)} />
                                </div>

                            </div>
                            <div className="collapsable-items-wrapper">
                                <div className="horizontal-separator" />

                                <LineManager translator={this.toLocaleLanguage} />

                                <ApproverDetails translator={this.toLocaleLanguage} />

                                <CustomDropdown label={this.toLocaleLanguage("location_address")} isActive={true} onToggle={() => { }}>
                                    <div className="add-sim-container">
                                        <div className="details-4-col-container address-detail-container">
                                            <CustomSearchableDropdownWrapper
                                                label={`${this.toLocaleLanguage("location_site_id_capital")}`}
                                                options={manageUserHrDetails.locationAddressDropdownList}
                                                selected={manageUserHrDetails.locationAddressDropdownList.length > 0 ? manageUserHrDetailsForm.locationId : null}
                                                onChange={(e) => this.onChangeLocationSite('manageUserHrDetailsForm.locationId', e)}
                                                placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                                fieldProp="manageUserHrDetailsForm.locationId"
                                                tagName='Key'
                                                optionLabelKey={{
                                                    Key: 'Key',
                                                    Value: 'Value'
                                                }}
                                                maxLength={MAX_LENGTH.limit_100}

                                                onSearchChange={this.handleLocationSearch}
                                                onLoadMore={this.loadMoreLocation}
                                                isLoading={manageUserHrDetails.isLocationLoading}
                                                hasMore={manageUserHrDetails.hasMoreLocation}
                                            />
                                            <InputField
                                                className="form-control"
                                                type="text"
                                                label={this.toLocaleLanguage("address_1_capital")}
                                                value={manageUserHrDetailsForm.address1 ?? ""}
                                                fieldProp="manageUserHrDetailsForm.address1"
                                                disabled={true}
                                            />
                                            <InputField
                                                className="form-control"
                                                type="text"
                                                label={this.toLocaleLanguage("address_2_capital")}
                                                value={manageUserHrDetailsForm.address2 ?? ""}
                                                fieldProp="manageUserHrDetailsForm.address2"
                                                disabled={true}
                                            />
                                            <InputField
                                                className="form-control"
                                                type="text"
                                                label={this.toLocaleLanguage("location_type_capital")}
                                                value={manageUserHrDetailsForm.locationType ?? ""}
                                                fieldProp="manageUserHrDetailsForm.locationType"
                                                disabled={true}
                                            />
                                            <InputField
                                                className="form-control"
                                                type="text"
                                                label={this.toLocaleLanguage("city_capital")}
                                                value={manageUserHrDetailsForm.city ?? ""}
                                                fieldProp="manageUserHrDetailsForm.city"
                                                disabled={true}
                                            />
                                            <InputField
                                                className="form-control"
                                                type="text"
                                                label={this.toLocaleLanguage("state_capital")}
                                                value={manageUserHrDetailsForm.state ?? ""}
                                                fieldProp="manageUserHrDetailsForm.state"
                                                disabled={true}
                                            />
                                            <InputField
                                                className="form-control"
                                                type="text"
                                                label={this.toLocaleLanguage("country_capital")}
                                                value={manageUserHrDetailsForm.country ?? ""}
                                                fieldProp="manageUserHrDetailsForm.country"
                                                disabled={true}
                                            />
                                            <InputField
                                                className="form-control"
                                                type="text"
                                                label={this.toLocaleLanguage("zip_capital")}
                                                value={manageUserHrDetailsForm.zip ?? ""}
                                                fieldProp="manageUserHrDetailsForm.zip"
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </CustomDropdown>

                                <Errors model="manageUserCostAllocationForm.CostCodePercent" show={this.state.error.propertyName === ERROR_SOURCE.cost_allocation_user && !this.state.error.isSuccess} className="has-error" />
                                <div className="control-container">
                                    <AddCostAllocation userId={userDetailsId} isReadOnly={this.props.isReadOnly} isReadAndExtractOnly={this.props.isReadAndExtractOnly} isReadAndWrite={this.props.isReadAndWrite} />
                                </div>

                                <AccessManagement translator={this.toLocaleLanguage} />
                            </div>


                        </div>
                        <div className='save-btn-container'>
                            <ConfirmationModal
                                ref={this.ConfirmationModal}
                                title={this.state.saveModal.title}
                                messageBody={this.state.saveModal.messageBody}
                                confirmAction={this.state.saveModal.confirmAction}
                                closeLabel={this.toLocaleLanguage("cancel_button")}
                                confirmLabel={this.toLocaleLanguage("yes_button")}
                                disabled={this.state.isSaving}
                            />

                            <NotificationModal
                                show={this.state.saveNotif.show}
                                title={this.state.saveNotif.title}
                                message={this.state.saveNotif.message}
                                handleModal={() => this.toggleSaveNotif(false)}
                                customClass={'comment-notification-modal modal-text-bold notification-footer'}
                            />


                            <div className="tooltip-container">
                                <div className="btn-tooltiptext">
                                    {this.props.isReadAndWrite ?
                                        <Button className='save-details-btn btn btn-primary'
                                            disabled={this.disableSaveChanges()}
                                            onClick={() => this.handleSaveManageHR(manageUserHrDetailsForm.employeeId)}
                                            type="button">
                                            Save Changes
                                        </Button>
                                        : null}
                                    <div className="save-tooltip-text-container">
                                        <span className="tooltip-text-save">{this.toLocaleLanguage("save_changes_on_user")}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </>
        );
    }
}

export default connect(
    state => {
        const { manageUserHrDetails, translation,
            form: { forms: { manageUserHrDetailsForm: { $form } } },
            manageUserCostAllocation
        } = state;

        const { manageUserHrDetailsForm, manageUserCostAllocationForm } = state.form;

        return {
            manageUserHrDetails,
            manageUserHrDetailsForm,
            $form,
            manageUserCostAllocation,
            manageUserCostAllocationForm,
            translation
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, hrDetailsActions, userCostAllocationActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(ManageUserForm);